<template>
	<div class="wrap">
		<ul class="product-list">
			<template v-for="(item,index) in items">
				<li v-if="!isCanSupply(item.id)" :key="item.id + 'a' + index">
			      <a class="img-wrapp" href="javascript:;" target="_blank"
			       v-lazy:background-image="item.imgUrl">
			       <img
                    	v-if="item.imgUrl"
                    	:src="item.imgUrl"
                    	:preview="index + '_' + item.id"
                  	>
			      </a>
			      <a class="p-name tx-ellipsis2" href="javascript:;">
			        {{item.name}}
			      </a>
			      
			      	<div class="s-name">
			          	<span>经销商30天销量：</span>{{item.sold30Days}} 件
			        </div>
			      <div class="s-info">
			        <a
				        data-type="btn"
				        class="btn btn-primary"
				        href="javascript:;"
				        @click="canSupply(item.id)"
				    >我能供货</a>
			      </div>
			    </li>
			</template>
		    <li v-if="items.length == 0 && !firstLoading" class="no-item">
		      <p class="title">没有符合条件的商品</p>
		      <p v-if="keyword" class="word">当前搜索的商品关键词：<span>{{keyword}}</span></p>
		    </li>
	  </ul>
	  	<div class="page-bottom" v-show="last && items.length > 0 && total > 1">
			<p>已经是最后一页了</p>
		</div>
	</div>
  
</template>

<script>
import bgimg from './../assets/img/none-img.png'
export default {
  props:["items","arr","last","firstLoading","keyword","total"],
  data(){
    return {
      bgimg
    }
  },
  methods:{
  	isCanSupply(val) {
      //是否已选择能供货  已选择的不显示
      return this.arr.includes(val);
    },
  	canSupply(val){
  		this.$emit("canSupply",val);
  	},
  }
};
</script>

<style lang="less" scoped>
	.wrap{
		margin-bottom: 80px;
	}
.product-list {
  min-width: 38rem;
  margin: 0 auto;
  padding: 1.25rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.product-list > li {
  margin: 0 .5rem 1rem;
  max-width: 16rem;
  min-width: 12.5rem;
  border: 0.0625rem #c1c1c1 solid;
  padding: 0.875rem;
  position: relative;
}
.product-list > li:hover {
  border-color: #17a2b8;
}
.product-list > li.no-item{
  max-width: none;
}
.product-list > li .p-label{
  position: absolute;
  top: .25rem;
  left: .25rem;
  background-color: #17a2b8;
  font-size: .875rem;
  color: #fff;
  padding: 0 .5rem;
  height: 1.25rem;
  line-height: 1.25rem;
}
.img-wrapp {
	position: relative;
  display: block;
  width: 16rem;
  padding-bottom: 100%;
  background-size: 100% auto;
  background-position: top center;
  background-repeat: no-repeat;
  margin-bottom: 0.5rem;
  > img{
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    width: 16rem;
    height: 100%;
    cursor: pointer;
  }
}
.img-wrapp.lazyload-success img{
  display: block;
}
.price-group {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
  padding: 0;
  font-size: 0.875rem;
  min-height: 3rem;
}
.price-group > div {
  min-width: 4rem;
}
.price-group .price {
  line-height: 1.5rem;
  color: #e83e8c;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
}
.price-group .num {
  line-height: 1.5rem;
  color: #666;
  text-align: center;
  font-size: .75rem;
}
.p-name {
  margin-bottom: 0.5rem;
  height: 2.5rem;
  line-height: 1.25rem;
  color: #17a2b8;
  font-size: 0.875rem;
}
.p-name:hover{
  text-decoration: underline;
}
.s-info {
	text-align: center;
  border-top: 0.0625rem #e6e6e6 solid;
  padding-top: 0.875rem;
}
.s-name {
  margin-bottom: 0.5rem;
  color: #666;
  font-size: 0.875rem;
}
.s-name i {
  color: #17a2b8;
  cursor: pointer;
}
.s-wangwang a{
	display: flex;
	align-items: center;
}
.s-wangwang a span{
	color: #17a2b8;
	font-size: 12px;
	margin-left: 5px;
}
.s-business {
  margin: 0;
  color: #666;
  font-size: 0.8575rem;
}
.product-list > li.no-item{
  border:none;
  width: 100%;
}
.product-list > li.no-item > p{
  color: #666;
  margin: 0 0 .5rem;
  font-size: .875rem;
}
.product-list > li.no-item > p.title{
  line-height: 2rem;
  font-size: 1.25rem;
}
.product-list > li.no-item > p.word, .product-list > li.no-item > p.price{
  font-size: .875rem;
}
.product-list > li.no-item > p span{
  color: #333;
  font-weight: 700;
}
.page-bottom{
			padding: 0 0 1.25rem ;
    	p{
    		margin: 0;
    		text-align: center;
    		color: #999;
    		font-size: 16px;
    	}
    }
@media (min-width: 700px) {
  .product-list {
    max-width: 38rem;
  }
}
@media (min-width: 970px) {
  .product-list {
    max-width: 57rem;
  }
}
@media (min-width: 1270px) {
  .product-list {
    max-width: 76rem;
  }
}
@media (min-width: 1870px) {
  .product-list {
    max-width: 114rem;
  }
}
</style>

